var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticClass:"py-0"},[_c('GChart',{attrs:{"type":"ComboChart","options":_vm.chartOptions,"data":_vm.updated_chart_data,"debounce":500,"events":_vm.chartEvents},on:{"ready":_vm.onChartReady}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }